import {
  IonButtons,
  IonHeader,
  IonIcon,
  IonLabel,
  IonMenuButton,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { help, settings } from "ionicons/icons";
import { Redirect, Route } from "react-router-dom";
import Settings from "./Settings";
import Support from "./Support";
import GeneralSettings from "./settings/GeneralSettings";
import NotificationSettings from "./settings/NotificationSettings";
import ModuleDefaultsSettings, {
  ModuleDefaultDetail,
} from "./settings/ModuleDefaultsSettings";
import {withAITracking} from "@microsoft/applicationinsights-react-js";
import {reactPlugin} from "../util/AppInsights";
import { useContext } from "react";
import { TranslationsContext } from "../util/Translations";

const SettingsTabs: React.FC = () => {
  const { translations } = useContext(TranslationsContext);
  return (
    <IonTabs>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{translations["lbl_settings"] || "Settings"}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonRouterOutlet id="settings">
        <Route exact path="/Settings">
          <Redirect to="/Settings/settings" />
        </Route>
        <Route exact path="/Settings/settings">
          <Settings />
        </Route>
        {/* Settings sub-pages stay in this outlet so the tab bar stays visible
            and going back returns to Settings at the same scroll position. */}
        <Route exact path="/Settings/settings/general">
          <GeneralSettings />
        </Route>
        <Route exact path="/Settings/settings/notifications">
          <NotificationSettings />
        </Route>
        <Route exact path="/Settings/settings/module-defaults">
          <ModuleDefaultsSettings />
        </Route>
        <Route exact path="/Settings/settings/module-defaults/:module">
          <ModuleDefaultDetail />
        </Route>
        <Route path="/Settings/support">
          <Support />
        </Route>
      </IonRouterOutlet>
      <IonTabBar slot="bottom">
        <IonTabButton tab="settings" href="/Settings/settings">
          <IonIcon icon={settings} />
          <IonLabel>{translations["lbl_settings"] || "Settings"}</IonLabel>
        </IonTabButton>
        <IonTabButton tab="support" href="/Settings/support">
          <IonIcon icon={help} />
          <IonLabel>{translations["lbl_support"] || "Support"}</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default  withAITracking(reactPlugin,SettingsTabs, "SettingsTabs");
